/**
 * xDataAudit — Phiên bản ứng dụng
 * Format: YY.MM.Number (ví dụ: 26.6.1 = tháng 6/2026, build số 1)
 * Cập nhật file này mỗi khi release.
 */
export const APP_VERSION = '26.7.1';
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
export const APP_BUILD_DATE = '2026-07-02';

/** Nhãn hiển thị đầy đủ (dùng ở LoginPage footer, sidebar bottom card) */
export const APP_VERSION_FULL = `v${APP_VERSION}`;
